<template>
  <section class="admin-content" id="contact-search">
    <Navbar />
    <main class="admin-main">
      <div class="bg-info m-b-30">
        <div class="container">
          <div class="row p-b-60 p-t-60">
            <div class="col-md-6 text-center mx-auto text-white p-b-30">
              <div class="m-b-10">
                <div class="avatar">
                  <!-- <div class="avatar-title rounded-circle fe fe-briefcase"></div> -->
                </div>
              </div>
              <p class="h3 text-dark">Make Payment</p>
            </div>
          </div>
        </div>
      </div>

      <section class="pull-up">
        <div class="container">
          <div class="row list">
            <div class="col-md-6 offset-md-3">
              <div class="card m-b-30">
                <div class="card-header"></div>

                <div class="card-body">
                  <div class="text-center"></div>

                  <div class="form-row">
                    <div class="form-group col-md-12">
                      <label for="inputEmail4">Beneficiary Name</label>
                      <input
                        type="text"
                        readonly
                        class="form-control"
                        v-model="wallet.account.accountName"
                        placeholder="Account Name"
                      />
                    </div>
                    <div class="form-group col-md-12">
                      <label for="inputPassword4"
                        >Beneficiary Account Number</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        v-model="wallet.account.accountNumber"
                        placeholder="Account Number"
                      />
                    </div>

                    <div class="form-group col-md-12">
                      <label for="inputPassword4">Amount </label>
                      <div class="input-group mb-3">
                        <div class="input-group-prepend">
                          <span class="input-group-text">
                            <i class="mdi mdi-currency-ngn"></i>
                          </span>
                        </div>
                        <input
                          required
                          type="number"
                          v-model="claims.total_sum"
                          class="form-control"
                          aria-label="Amount (to the nearest dollar)"
                        />
                        <div class="input-group-append">
                          <span class="input-group-text">.00</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="form-group col-md-12">
                      <label for="inputEmail4">Narration</label>
                      <input
                        required
                        type="text"
                        class="form-control"
                        v-model="narration"
                        placeholder="Narration"
                      />
                    </div>

                    <div class="form-group col-md-12">
                      <label for="inputEmail4">Password</label>
                      <input
                        required
                        type="password"
                        class="form-control"
                        v-model="password"
                        placeholder="Password"
                      />
                    </div>
                  </div>

                  <div class="form-group">
                    <button
                      class="btn btn-info btn-block"
                      @click="registerUser"
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="vld-parent">
            <loading
              :active.sync="isLoading"
              loader="dots"
              :can-cancel="true"
              :is-full-page="fullPage"
            ></loading>
          </div>
        </div>
      </section>
    </main>
  </section>
</template>
  
  <script>
import Navbar from "@/views/Navbar.vue";
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
// Init plugin
import moment from "moment";
moment().format();

export default {
  components: {
    Navbar,
    Loading,
  },
  data() {
    return {
      isLoading: false,
      fullPage: true,
      password: "",
      narration: "",
      state: "",
      claims: "",
      provider: "",
      wallet: {
        account: "",
      },
    };
  },
  beforeMount() {
    this.user = JSON.parse(localStorage.getItem("user"));
  },
  methods: {
    getRecipient() {
      if (this.$route.params.type == "claims") {
        this.axios
          .get(`/api/v1/auth/treatclaimsprovider`, {
            params: {
              paginate_value: 100,
              provider_id: this.$route.params.id,
              date: this.date,
              from: this.from,
              to: moment().format("YYYY-MM-DD"),
            },
          })
          .then((response) => {
            this.claims = response.data;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      }
    },

    getProvider() {
      this.user = JSON.parse(localStorage.getItem("user"));
      this.axios
        .get(`/api/v1/auth/detailedProviderHmo/${this.$route.params.id}`)
        .then((response) => {
          this.provider = response.data.data[0];
          this.getWallet(this.provider);
        })
        .catch((error) => {
          console.error(error);
        });
    },

    getWallet(enrollee) {
      this.isLoading = true;
      this.axios
        .get(`/api/v1/auth/wallet/${enrollee.virtual_account}`)
        .then((response) => {
          console.log(response);
          this.wallet = response.data.data;
          this.$toasted.success("Wallet Fetched", {
            position: "top-center",
            duration: 3000,
          });
          this.isLoading = false;
        })
        .catch((error) => {
          console.error(error);
          this.$toasted.error("Error!", {
            position: "top-center",
            duration: 3000,
          });
          this.isLoading = false;
        });
    },

    registerUser() {
      this.user = JSON.parse(localStorage.getItem("user"));
      this.isLoading = true;
      this.axios
        .post("/api/v1/auth/wallet/transfer", {
          debitAccountId: "6871a29c5d903780312c2b5b",
          creditAccountId: this.wallet.account._id,
          //   beneficiaryBankCode: this.provider.lastname,
          amount: parseInt(this.claims.total_sum),
          narration: this.narration,
          email: this.user.email,
          password: this.password,
          //   paymentReference: this.paymentReference,
        })
        .then((response) => {
          console.log(response);
          this.isLoading = false;

          this.$toasted.info("Payment made Successfully", {
            position: "top-center",
            duration: 3000,
          });

          this.$router.push(`/fund-manager`);
        })
        .catch((error) => {
          console.log(error.response);
          this.isLoading = false;

          this.$toasted.error(`Password Incorrect`, {
            position: "top-center",
            duration: 3000,
          });
        });
    },
  },
  created() {
    this.getRecipient();
    this.getProvider();
  },
};
</script>
  